<div class="stepper" [class]="'stepper--' + orientation + ' stepper--' + size">

  <!-- Connector before first step -->
  <div class="stepper-step__connector stepper-step__connector--before-first" *ngIf="showConnectors"></div>

  <div *ngFor="let step of steps; let i = index; let last = last;" class="stepper-step step step-{{ step.status }}"
    [class.stepper-step--clickable]="allowStepNavigation && isStepAccessible(step, i)"
    [class.stepper-step--disabled]="step.disabled" (click)="onStepClick(step, i)">

    <!-- Step Circle/Icon -->
    <div class="stepper-step__circle">
      <div class="stepper-step__icon" *ngIf="step.status === 'completed'">
        <icon name="check"></icon>
      </div>
      <div class="stepper-step__number" *ngIf="step.status !== 'completed'">
        {{ i + 1 }}
      </div>
    </div>

    <!-- Step Content -->
    <div class="stepper-step__content">
      <div class="stepper-step__title">
        {{ step.title | translate }}
      </div>
      <div *ngIf="showStepSubtitles && step.subtitle" class="stepper-step__subtitle">
        {{ step.subtitle | translate }}
      </div>
    </div>

    <!-- Connector Line -->
    <div *ngIf="showConnectors && !last" class="stepper-step__connector"
      [ngClass]="{'stepper-step__connector--completed': step.status === 'completed'}">
    </div>
  </div>

  <!-- Connector after last step -->
  <div class="stepper-step__connector stepper-step__connector--after-last" *ngIf="showConnectors"></div>
</div>